/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// TOPに戻るボタン
function backToTop () {
  let rootMarginPx = "0px 0px 0px 0px";
  const options = {
    rootMargin: rootMarginPx,
    threshold: [0, 1.0]
  };
  const observer = new IntersectionObserver(backToTopShow, options);
  observer.observe(document.querySelector('.announcement-bar'));
  function backToTopShow(entries) {
    entries.forEach(entry => {
      if (entry.intersectionRatio >= 1) {
        document.querySelector('#backToTopBtn').classList.remove("visible");
      } else {
        document.querySelector('#backToTopBtn').classList.add("visible");
      }
    });
  }
}

// メガメニュー内スクロール
function megaMenuScroll() {
  const scrollBtn = document.querySelectorAll('.c-mega-menu__arrow');

  scrollBtn.forEach((button) => {
    let wrapper = button.parentElement,
        inner = wrapper.querySelector('.mega-menu__inner'),
        rightScrollOffset = inner.clientWidth / 2,
        leftScrollOffset = -inner.clientWidth / 2,
        columnWidth = 0;

    // コンテンツ幅によるボタン非表示切り替え
    inner.querySelectorAll('.mega-menu__column').forEach((column) => {
      columnWidth = columnWidth + column.clientWidth + 50;
    })

    if (columnWidth < inner.clientWidth) {
      button.style.display = "none"
    }
    
    // スクロール動作制御
    button.addEventListener('click', function(){
      if (button.classList.contains('next')) {
        inner.scrollBy({
          left: rightScrollOffset,
          behavior: "smooth",
        });
      } else {
        inner.scrollBy({
          left: leftScrollOffset,
          behavior: "smooth",
        });
      }
    })
  })

}

window.addEventListener('DOMContentLoaded',function(){
  megaMenuScroll();
})

window.addEventListener('load',function(){
  backToTop();
})

// 選んだ色に写真が無いときは、商品ページの大きい画像の欄に「No image」を出す（2026-10-20 StoreHero / Issue #14）
// - 対象は、ほかの色には色ごとの写真があるのに、選んだ色のどのバリエーションにも写真が無い商品だけ
// - 選んだバリエーションに写真が無くても、同じ色の別のバリエーション（型番違い等）に写真があれば、その写真に切り替える（2026-10-24 追加）
// - サムネイルを押す・矢印・スワイプで写真が切り替わったら、枠を外してその写真を出す
// - 「色」の選択肢は名前で見分ける（表示言語ごとに翻訳される）。main-cart.liquid・main-customers-order.liquid と同じ一覧
const C_NOIMG_COLOR_OPTION_NAMES = ['color', 'colour', 'カラー', '色', '顏色', '颜色', 'สี'];

function cNoimgColorKey(product) {
  const colorIndex = product.options.findIndex((option) => {
    const name = typeof option === 'object' ? option.name : option;
    return C_NOIMG_COLOR_OPTION_NAMES.includes(String(name).toLowerCase());
  });
  return colorIndex === -1 ? null : 'option' + (colorIndex + 1);
}

function cNoimgIsColorWithoutImage(product, variant) {
  if (!product || !variant || variant.featured_media) return false;

  const key = cNoimgColorKey(product);
  if (!key) return false;

  const variantsWithImage = product.variants.filter((item) => item.featured_media);
  return variantsWithImage.length > 0 && !variantsWithImage.some((item) => item[key] === variant[key]);
}

// 選んだバリエーションに写真が無く、同じ色の別のバリエーションに写真があるとき、いま別の色の写真を出していればその写真に切り替える。
// テーマはこの場合に写真を切り替えないため、直前に選んでいた別の色の写真が残ってしまう
function cNoimgShowSameColorImage(gallery, product, variant) {
  if (!variant || variant.featured_media) return;

  const key = cNoimgColorKey(product);
  if (!key) return;

  const sameColorMediaIds = product.variants
    .filter((item) => item.featured_media && item[key] === variant[key])
    .map((item) => String(item.featured_media.id));
  if (sameColorMediaIds.length === 0) return;

  const selected = gallery.querySelector('.product-gallery__carousel-item.is-selected');
  if (selected && sameColorMediaIds.includes(selected.getAttribute('data-media-id'))) return;

  // テーマのサムネイルの切り替え（ProductGallery._onThumbnailClicked）を使う。リンク先（画像ファイル）へは移動させない
  const thumbnail = gallery.querySelector(`.product-gallery__thumbnail[data-media-id="${sameColorMediaIds[0]}"]`);
  if (!thumbnail) return;
  thumbnail.addEventListener('click', (event) => event.preventDefault(), { once: true });
  thumbnail.click();
}

function cNoimgClear(gallery) {
  gallery.classList.remove('c-noimg-active');
  gallery.cNoimgCell = null;
}

function cNoimgUpdate(gallery) {
  const product = gallery.cNoimgProduct;
  const options = gallery.cNoimgOptions;
  const key = cNoimgColorKey(product);
  let variant = product.variants.find((item) => item.options.every((value, index) => value === options[index]));

  // 選択肢の組み合わせが無いとき（型番が色ごとに決まっている商品で、色だけ変えて前の型番が残った場合など）は、選んでいる色だけで判定する。
  // 色の値だけを持つ候補を渡すと、同じ色に写真があればその写真に切り替わり、どのバリエーションにも無ければ No image になる（2026-10-27 レビュー指摘）
  if (!variant && key) variant = { [key]: options[Number(key.replace('option', '')) - 1] };

  if (cNoimgIsColorWithoutImage(product, variant)) {
    gallery.classList.add('c-noimg-active');
    gallery.cNoimgCell = gallery.querySelector('.product-gallery__carousel-item.is-selected');
  } else {
    cNoimgClear(gallery);
    cNoimgShowSameColorImage(gallery, product, variant);
  }
}
// 一覧・検索から色を指定せずに開いたとき（URL に ?variant= が無いとき）、最初に選ばれた色に写真が無ければ、写真のある色の購入できるバリエーションを選び直す。
// テーマは購入できる最初のバリエーションを選ぶため、その色に写真が無いと開いた直後が No image になる（2026-10-29）。写真のある色がすべて売り切れなら選び直さない
function cNoimgSelectColorWithImage(section, product, options) {
  const key = cNoimgColorKey(product);
  const selected = product.variants.find((item) => item.options.every((value, index) => value === options[index]));
  if (!key || !cNoimgIsColorWithoutImage(product, selected)) return;

  const colorsWithImage = product.variants.filter((item) => item.featured_media).map((item) => item[key]);
  const target = product.variants.find((item) => item.available && colorsWithImage.includes(item[key]));
  if (!target) return;

  // テーマの選択肢の切り替え（ProductVariants._onOptionChanged）を使う。価格・カートに入る商品・URL もテーマが更新する
  target.options.forEach((value, index) => {
    const input = [...section.querySelectorAll(`input.product-form__single-selector[data-option-position="${index + 1}"]`)]
      .find((item) => item.value === value);
    if (input && !input.checked) input.click();
  });
}
function cNoimgInit(root) {
  root.querySelectorAll('[data-product-json]').forEach((json) => {
    const section = json.closest('.shopify-section');
    const gallery = section && section.querySelector('.product-gallery');
    if (!gallery || gallery.cNoimgReady) return;
    gallery.cNoimgReady = true;

    // ページを開いた直後（URL で色を指定した場合を含む）
    try {
      const data = JSON.parse(json.textContent);
      gallery.cNoimgProduct = data.product;
      gallery.cNoimgOptions = data.product.variants.find((item) => item.id === data.selected_variant_id).options.slice();
    } catch (error) {
      return;
    }
    if (!new URLSearchParams(window.location.search).has('variant')) {
      cNoimgSelectColorWithImage(section, gallery.cNoimgProduct, gallery.cNoimgOptions);
    }
    cNoimgUpdate(gallery);

    // 矢印・スワイプで別の写真に切り替わったら枠を外す
    new MutationObserver(() => {
      if (!gallery.cNoimgCell) return;
      if (gallery.querySelector('.product-gallery__carousel-item.is-selected') !== gallery.cNoimgCell) cNoimgClear(gallery);
    }).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });

    // サムネイルを押したら枠を外す（いま選ばれている写真と同じサムネイルを押した場合も）
    gallery.addEventListener('click', (event) => {
      if (event.target.closest('.product-gallery__thumbnail')) cNoimgClear(gallery);
    }, true);
  });
}

// 色の切り替え。テーマの variant:changed は使わない（売り切れの商品などでテーマの処理が途中で止まり、発火しないことがあるため）。
// テーマ（ProductVariants._onOptionChanged）と同じく、選択肢の位置と値から選ばれているバリエーションを割り出す
document.addEventListener('change', (event) => {
  const input = event.target.closest('.product-form__single-selector');
  const section = input && input.closest('.shopify-section');
  const gallery = section && section.querySelector('.product-gallery');
  if (!gallery || !gallery.cNoimgOptions) return;

  gallery.cNoimgOptions[parseInt(input.getAttribute('data-option-position'), 10) - 1] = input.value;
  cNoimgUpdate(gallery);
});

// カート・会員ページの注文履歴: この行のバリエーションに写真が無く、同じ色の別のバリエーションに写真があれば、その写真に差し替える（2026-10-24 追加）
// Shopify は写真の無いバリエーションに商品の1枚目（別の色のことがある）を出すため。どの色にも写真が無い場合の No image は Liquid が出す
// （main-cart.liquid・main-customers-order.liquid は GP の改修範囲の上限 15 行に達しているので、差し替えはここで行う）
function cNoimgFixLineItemImages() {
  const targets = [...document.querySelectorAll('.line-item')].map((row) => {
    const image = row.querySelector('.line-item__image-wrapper img');
    const link = row.querySelector('a.line-item__title[href*="/products/"]');
    if (!image || !link || row.querySelector('.c-noimg')) return null;

    const url = new URL(link.getAttribute('href'), window.location.origin);
    const variantId = Number(url.searchParams.get('variant'));
    return variantId ? { image, variantId, productPath: url.pathname } : null;
  }).filter(Boolean);
  if (targets.length === 0) return;

  const products = {};
  targets.forEach(({ productPath }) => {
    if (!products[productPath]) {
      products[productPath] = fetch(productPath + '.js')
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null); // 取得できなければ今の写真のまま
    }
  });

  targets.forEach(({ image, variantId, productPath }) => {
    products[productPath].then((product) => {
      if (!product) return;
      const variant = product.variants.find((item) => item.id === variantId);
      const key = cNoimgColorKey(product);
      if (!variant || variant.featured_image || !key) return;

      const sameColor = product.variants.find((item) => item.featured_image && item[key] === variant[key]);
      if (!sameColor) return;

      const src = new URL(sameColor.featured_image.src, window.location.origin);
      src.searchParams.set('width', '360');
      image.src = src.toString();
      image.alt = sameColor.featured_image.alt || image.alt;
      image.style.objectFit = 'contain'; // 枠の縦横比は元の写真で決まっているため、違う比率の写真でも歪ませない
    });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  cNoimgInit(document);
  cNoimgFixLineItemImages();
});
document.addEventListener('shopify:section:load', (event) => cNoimgInit(event.target));